import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { user } from "src/components/login/login";
import { myAxios } from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
import Form from "../form";
export const items = [
{title: "weeklyMaintenanceZerkFittingsBlock1", type: "display", content: <div className = "my-2 text-secondary font-weight-bold font-italic"><p>PPE required harness & restraint tied off on vehicle.</p></div>}, 
{title: "Driver", type: "text", required: true, default: user.userName}, 
{title: "Truck Number", type: "select", required: true, options: []}, 
{title: "Date", type: "date", required: true}, 
{title: "Location", type: "text", required: true}, 
{title: "Battery powered or electric grease gun 10,000 psi used.", type: "radio", required: true}, 
{title: "Approver Notes"}
];
//--------------------------------------------------------------------------------------------
export default function WeeklyMaintenanceZerkFittings({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList, 
    forms
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [truckNumbers, setTruckNumbers] = useState([]);
    items[1].options = [
        ...truckNumbers.map(truckNumber => ({
            value: truckNumber, 
            label: truckNumber
        }))
    ];
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            // ------------------------------
            setShowLoader(true);
            const resTrucks = await myAxios("common/readTruckNumbers.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTrucks) return;
            // ------------------------------
            setTruckNumbers(resTrucks.data.map(d => d.truckNumber));
        }
        getData();
        return () => {isMounted = false;}
    },[]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}
            
            items = {items}
            
            picsLimit = {1}

            forms = {forms}
        />
    )    
}